import router from '@/router/router'

export default {
	install() {
		router
			.isReady()
			.then(async () => {
				const { registerSW } = await import('virtual:pwa-register')
				registerSW({ immediate: true })
			})
			// Offline support is not worth an unhandled rejection when the chunk is gone after a deploy.
			.catch(() => undefined)
	},
}
